import moment from 'moment';
import { enableCancellationRules } from 'helper/configuration';
import {
  FETCH_DELIVERY,
  CANCEL_ORDER,
  FETCH_CANCEL_REASONS,
  HISTORY_DELIVERIES,
  ONGOING_DELIVERIES,
  PAX_FETCH_HISTORY_DELIVERIES,
  PAX_CANCEL_DELIVERY,
  PAX_FETCH_ONGOING_DELIVERIES,
} from './endpoint-constants';
import { ORDER_STATUS } from '../components/history/filter-form/filter-form';

const getHistoryEpt = params => {
  const { endpoints } = window.Grab.config;
  const { geAPIV2 } = endpoints;
  return `${geAPIV2}${FETCH_DELIVERY}?${new URLSearchParams(
    params,
  ).toString()}`;
};

const getHistoryNotificationEpt = companyID => {
  const { endpoints } = window.Grab.config;
  const { geAPIV2 } = endpoints;

  const fromDate = moment()
    .subtract(2, 'days')
    .format('YYYY-MM-DD');
  const toDate = moment().format('YYYY-MM-DD');
  const orderState = ORDER_STATUS.ALL;

  return `${geAPIV2}${FETCH_DELIVERY}?&fromDate=${fromDate}&toDate=${toDate}&limit=999&orderState=${orderState}&companyID=${companyID}`;
};

export const getCancelDeliveryEpt = deliveryID => {
  const { endpoints } = window.Grab.config;
  const { geAPI } = endpoints;
  return `${geAPI}${CANCEL_ORDER.replace('{delivery_id}', deliveryID)}`;
};

export const getCancelReasonsEpt = () => {
  const { endpoints } = window.Grab.config;
  const { geAPI } = endpoints;
  return `${geAPI}${FETCH_CANCEL_REASONS}`;
};

export const getCancelReasonsWithDeliveryID = (
  deliveryID,
  expressServiceID = 0,
) => {
  const { endpoints } = window.Grab.config;
  const { geAPI } = endpoints;
  return `${geAPI}${FETCH_CANCEL_REASONS}?deliveryID=${deliveryID}&expressServiceID=${expressServiceID}`;
};

// ----------------------V2------------------------

const getOngoingDeliveriesEpt = ({ companyID, keywords }) => {
  const { endpoints } = window.Grab.config;
  const urlSearchParams = new URLSearchParams();
  urlSearchParams.append('params.companyID', companyID);
  if (keywords) {
    urlSearchParams.append('params.keywords', keywords);
  }
  urlSearchParams.append('params.limit', 1000);
  return `${
    endpoints.geAPIV2
  }${ONGOING_DELIVERIES}?${urlSearchParams.toString()}`;
};
const getPaxOngoingDeliveriesEpt = () => {
  const { endpoints } = window.Grab.config;
  return `${endpoints.geAPIV2}${PAX_FETCH_ONGOING_DELIVERIES}`;
};
const getHistoryDeliveriesEpt = queryString => {
  const { endpoints } = window.Grab.config;
  return `${endpoints.geAPIV2}${HISTORY_DELIVERIES}?${queryString}`;
};

const getPaxHistoryDeliveriesEpt = queryString => {
  const { endpoints } = window.Grab.config;
  return `${endpoints.geAPIV2}${PAX_FETCH_HISTORY_DELIVERIES}?${queryString}`;
};

export const getPaxCancelDeliveryEpt = ({ deliveryID, expressServiceID }) => {
  const { endpoints } = window.Grab.config;
  const { geAPIV2 } = endpoints;
  return `${geAPIV2}${PAX_CANCEL_DELIVERY}/${deliveryID}?input.expressServiceID=${expressServiceID}&input.enableCancellationRules=${enableCancellationRules()}`;
};

const getDeliveriesV3Ept = ({
  status,
  statusExclude = false,
  source,
  sourceExclude = false,
  startUnixTime,
  endUnixTime,
}) => {
  let qs = new URLSearchParams({
    startUnixTime,
    endUnixTime,
    ...(source && {
      source,
      sourceExclude,
    }),
  }).toString();
  if (status && status.length > 0) {
    qs += `&statusExclude=${statusExclude}`;
    status.forEach(s => {
      qs += `&status=${s}`;
    });
  }
  const { endpoints } = window.Grab.config;
  const { geWebAPIBase } = endpoints;
  return `${geWebAPIBase}/v3/deliveries?${qs}`;
};

export default {
  getHistoryEpt,
  getCancelDeliveryEpt,
  getCancelReasonsEpt,
  getHistoryNotificationEpt,
  getPaxHistoryDeliveriesEpt,
  getOngoingDeliveriesEpt,
  getHistoryDeliveriesEpt,
  getPaxCancelDeliveryEpt,
  getPaxOngoingDeliveriesEpt,
  getDeliveriesV3Ept,
};
